export default "__VITE_ASSET__C7rkdc8f__"